import axios from 'axios';
import apiConfig from './api';
import Vue from 'vue';

const getConfig = (str) => {
    var keys = String(str).split("."),
        config = apiConfig;
    keys.forEach(key => {
        config = config[key];
    })
    console.log("query config",keys,config)
    return config;
}

export default function request(api,config = {}) {
  // 1.创建axios实例
  const instance = axios.create({
    baseURL: 'http://localhost:4001/api/v1',
    timeout: 5000
  })

  instance.interceptors.request.use(config => {
    config = Object.assign(config, getConfig(api))
    if (config.type && config.type == "formData") {
        config.headers["Content-type"] = "multipart/form-data";
    } else {
        config.headers["Content-type"] = "application/json";
        config.data = JSON.stringify(config.data);
    }
    return config;
  })

  // 2.响应拦截
  instance.interceptors.response.use(res => {
    const data = res.data;
    if(data.code != 200) {
        Vue.prototype.$Msg(data.message)
    }
    return data;
  }, err => {
    console.log(err)
  })
  // 3.发送真正的网络请求
  return instance(config)
}